import { useMemo } from 'react'

import { ArticleList, IArticleListItem } from 'src/components/molecules'

import { toShortRelativeTime } from '../../domain/portfolio-news-published-display'
import type { IPortfolioNewsArticleEntity } from '../../types'

interface IRelatedNewsMobileListProps {
  articles: IPortfolioNewsArticleEntity[]
  onArticleClick?: (article: IPortfolioNewsArticleEntity) => void
  ariaLabel?: string
}

export const RelatedNewsMobileList = ({
  articles,
  onArticleClick,
  ariaLabel,
}: IRelatedNewsMobileListProps): JSX.Element => {
  const items: IArticleListItem[] = articles.map(
    (article): IArticleListItem => ({
      id: article.id,
      title: article.articleName,
      meta: toShortRelativeTime(article.publishedDisplay),
    }),
  )

  const articlesById = useMemo(
    (): Map<string, IPortfolioNewsArticleEntity> =>
      new Map(
        articles.map((article): [string, IPortfolioNewsArticleEntity] => [
          article.id,
          article,
        ]),
      ),
    [articles],
  )

  const handleItemClick = onArticleClick
    ? (item: IArticleListItem): void => {
        const article = articlesById.get(item.id)
        if (article) {
          onArticleClick(article)
        }
      }
    : undefined

  return (
    <ArticleList
      items={items}
      ariaLabel={ariaLabel}
      onItemClick={handleItemClick}
      layout="inline-meta"
    />
  )
}
